// extracted by mini-css-extract-plugin
export default {"address":"PracticeAddress_address__Zlp-+"};